export interface Paging {
  skip: number;
  take: number;
  total: number;
}

const defaultValue = {
  skip: 0,
  take: 10,
  total: 0
};

// eslint-disable-next-line no-redeclare
export const Paging = {
  defaultValue
};
